import * as React from 'react';
import { validate } from 'uuid';
import { Types } from '@grandvisionhq/graphql';
import { useLocalStorage } from '@grandvisionhq/lib-utils-w3c';
import { useSetLoyaltyDetails } from './use-set-loyalty-details.js';

const useHandleScridId = ({ cartId , cartHash , cardNumber  })=>{
    const [scrid, , reset] = useLocalStorage('SCRID_KEY');
    const onCompleted = React.useCallback(()=>{
        reset();
    }, [
        reset
    ]);
    const { setLoyaltyCardNumber , updateError , isUpdating  } = useSetLoyaltyDetails({
        onCompleted
    });
    const shouldUpdateScrid = React.useCallback(()=>{
        const isScridAlreadySaved = cardNumber && scrid == cardNumber;
        return Boolean(scrid && validate(scrid) && !updateError && !isScridAlreadySaved);
    }, [
        cardNumber,
        scrid,
        updateError
    ]);
    const checkAndUpdateScridId = React.useCallback(()=>{
        if (shouldUpdateScrid() && !isUpdating) {
            setLoyaltyCardNumber(scrid, cartId, cartHash || null, Types.LoyaltyCardNumber.UUID);
        }
    }, [
        shouldUpdateScrid,
        isUpdating,
        setLoyaltyCardNumber,
        scrid,
        cartId,
        cartHash
    ]);
    return {
        checkAndUpdateScridId
    };
};

export { useHandleScridId };
//# sourceMappingURL=use-handle-scrid-id.js.map
